var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.448 24.468a3.78 3.78 0 0 0-3.784 3.784 3.78 3.78 0 0 0 3.784 3.784 3.78 3.78 0 0 0 3.784-3.784 3.78 3.78 0 0 0-3.784-3.784m0-15.135a3.78 3.78 0 0 0-3.784 3.784A3.78 3.78 0 0 0 8.448 16.9a3.78 3.78 0 0 0 3.784-3.784 3.78 3.78 0 0 0-3.784-3.784m0 30.27a3.795 3.795 0 0 0-3.784 3.784c0 2.069 1.715 3.784 3.784 3.784s3.784-1.715 3.784-3.784a3.795 3.795 0 0 0-3.784-3.784m7.567 6.307h35.316v-5.045H16.015zm0-15.135h35.316v-5.046H16.015zm0-20.18v5.044h35.316v-5.045z"
  })));
};
export default SvgList;